import { createContext } from 'react';
import configuration from 'config';

const AppContext = createContext({settings: configuration.settings, filters: configuration.filters});

export default AppContext;
